import React from "react";

export default function DropdownIcon() {
  return (
    <svg
      width="11"
      height="6"
      viewBox="0 0 11 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.97072 1.08816C0.97072 1.02932 1.00014 0.955772 1.04427 0.911642C1.14724 0.808672 1.30905 0.808672 1.41202 0.896932L5.35431 4.60386C5.42785 4.67741 5.56025 4.67741 5.64851 4.60386L9.59079 0.896932C9.69376 0.793962 9.85557 0.808672 9.95854 0.911642C10.0615 1.01461 10.0468 1.17642 9.94383 1.27939L6.00155 4.98632C5.72206 5.23639 5.28076 5.23639 5.01598 4.98632L1.05898 1.27939C1.00014 1.22055 0.97072 1.16171 0.97072 1.08816Z"
        fill="#637381"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.72659 0.546578L5.50141 4.09604L9.26422 0.557869C9.58459 0.244537 10.042 0.329403 10.2914 0.578788C10.612 0.899434 10.5277 1.36122 10.2767 1.61224L10.2664 1.62248L6.31552 5.33722C5.86257 5.74249 5.1445 5.7544 4.69352 5.32924C4.69327 5.32901 4.69377 5.32948 4.69352 5.32924L0.725953 1.61241C0.602762 1.48922 0.5 1.31674 0.5 1.08816C0.5 0.905899 0.578011 0.712197 0.711421 0.578787C0.994701 0.295506 1.43557 0.297138 1.71836 0.539529L1.72659 0.546578ZM5.01598 4.98632C5.28076 5.23639 5.72206 5.23639 6.00155 4.98632L9.94383 1.27939C10.0468 1.17642 10.0615 1.01461 9.95854 0.911642C9.85557 0.808672 9.69376 0.793962 9.59079 0.896932L5.64851 4.60386C5.56025 4.67741 5.42785 4.67741 5.35431 4.60386L1.41202 0.896932C1.30905 0.808672 1.14724 0.808672 1.04427 0.911642C1.00014 0.955772 0.97072 1.02932 0.97072 1.08816C0.97072 1.16171 1.00014 1.22055 1.05898 1.27939L5.01598 4.98632Z"
        fill="#637381"
      />
    </svg>
  );
}
